import { render, staticRenderFns } from "./LogInSwitch.vue?vue&type=template&id=44dab2c4&scoped=true&"
import script from "./LogInSwitch.vue?vue&type=script&lang=js&"
export * from "./LogInSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LogInSwitch.vue?vue&type=style&index=0&id=44dab2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dab2c4",
  null
  
)

export default component.exports